export const environment = {
  production: true,
  baseUrl: 'https://is.cibs.cz/api/v1/index.php',
  sentryDns: 'https://aca64d0884a84dbda0df948bf6d497b2@sentry.ogapps.cloud/12',
  dbVersion: 'stable',
  addressSearchUrl: 'https://pelias.mango.cloud/v1',
};
